import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

const state = {
}

const actions = {
  init: ({ commit }) => {
    console.debug('called M0303BiddingGuide init')
    return client.postData({ data: { init: { api: 'M0303BiddingGuideService.getBiddingGuide' } } })
      .then((data) => {
        if (data.init.output.status === false) { throw new Error(data.init.output.message) } else {
          commit('FIND_ALL', data.init.output)
        }
      }).catch((err) => { throw err })
  },
  saveBiddingGuide: ({ commit }, row) => {
    console.debug('called M0303BiddingGuide save')
    return client.postData({ data: { save: { api: 'M0303BiddingGuideService.saveBiddingGuide', input: row } } })
      .then((data) => {
        if (data.save.output.status === false) { throw new Error(data.save.output.message) } else {
          commit('FIND_ALL', data.save.output)
        }
      }).catch((err) => { throw err })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
